import { computed } from 'vue';
import { useAccount } from './useAccount';

export const DEFAULT_PAYMENT_METHODS = [
  'Pix',
  'Boleto bancário',
  'Cartão de crédito',
  'Cartão de débito',
  'Dinheiro',
  'Transferência',
];

export const normalizePaymentMethods = custom => {
  const seen = new Set();
  return [...DEFAULT_PAYMENT_METHODS, ...(Array.isArray(custom) ? custom : [])]
    .filter(value => typeof value === 'string' && value.trim())
    .map(value => value.trim())
    .filter(value => {
      const key = value.toLocaleLowerCase('pt-BR');
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

export function usePaymentMethods() {
  const { currentAccount } = useAccount();
  const customPaymentMethods = computed(() => {
    const methods = currentAccount.value?.settings?.custom_payment_methods;
    return Array.isArray(methods) ? methods : [];
  });
  const allPaymentMethods = computed(() =>
    normalizePaymentMethods(customPaymentMethods.value)
  );
  const paymentMethodOptions = computed(() =>
    allPaymentMethods.value.map(method => ({ value: method, label: method }))
  );
  return { customPaymentMethods, allPaymentMethods, paymentMethodOptions };
}
